import { render, staticRenderFns } from "./TemplateBrowser.vue?vue&type=template&id=490d0feb&scoped=true"
import script from "./TemplateBrowser.vue?vue&type=script&lang=js"
export * from "./TemplateBrowser.vue?vue&type=script&lang=js"
import style0 from "./TemplateBrowser.vue?vue&type=style&index=0&id=490d0feb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490d0feb",
  null
  
)

export default component.exports